// @flow

import styled, { css } from 'styled-components';
import { fontFamily } from '../font-family';

export const Button = styled.button`
  font-family: ${fontFamily.sansSerif};
  font-size: 17px;
  letter-spacing: 0.60px;
  height: 68px;
  padding: 1em;
  background: black;
  color: white;
  border: none;
  border-radius: 5px;
  outline: none;

  ${(props) => props.block && css`
    display: block;
    width: 100%;
  `}
`;
